module.exports = __webpack_public_path__ + "0bd13fcebd5d27cc2f2afe844f4b4acb.png";